module.exports = __webpack_public_path__ + "img/main-banner-960.8ea1d44e.jpg";